import { useCurrent } from 'contexts/index'
import { CheckboxGroup } from '..'

const GenderCheckboxGroup = props => {
  const { genderOptions } = useCurrent()
  return <CheckboxGroup {...props} options={genderOptions} />
}

export default GenderCheckboxGroup
